
import React, { Component } from 'react';
import noDataImg from "images/no_img.png";
require("./index.scss");


class NoDataPicture extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {
        // let { total, pageSize, currentPage } = this.props;
        return (

            <img src={noDataImg} />
        )
    }
}

export default NoDataPicture;